<section>
  @if (displayFirstSection()) {
    <div [class.has-aside-date]="haveAsideDate" class="main-content">
      <!--    Description    -->
      @if (profileDataService.expertise.value && profileDataService.expertise.value.length > 0) {
        <exl-content-box>
          <div exl-content-box-title>
            <h2>{{ 'research.profile.overview.expertise' | translate }}</h2>
          </div>
          @for (expertise of profileDataService.expertise.value; track expertise) {
            <div
              class="rich-text-reset margin-bottom-sm"
              exl-content-box-body
              >
              <exl-expandable-text
                [buttonInline]="false"
                [buttonLabel]="'research.profile.overview.show.more' | translate"
                [visibleLines]="20"
                >
                <exl-html-display [content]="expertise"></exl-html-display>
              </exl-expandable-text>
            </div>
          }
        </exl-content-box>
      }
      <!-- Engagements -->
      @if (profileDataService.engagements.value?.length) {
        <exl-content-box>
          <div exl-content-box-title>
            <h2>
              {{ 'research.profile.overview.engagements' | translate }}
            </h2>
          </div>
          <mat-list exl-content-box-body>
            <exl-expandable-text
              [buttonInline]="false"
              [buttonLabel]="'research.profile.overview.show.more' | translate"
              [visibleLines]="10"
              role="list">
              @for (engagement of profileDataService.engagements.value; track engagement; let i = $index; let last = $last) {
                <mat-list-item
                  class="is-wrapping hasnt-padding margin-bottom-xs"
                  role="listitem">
                  <div >
                    {{ engagement | translate }}
                  </div>
                </mat-list-item>
              }
            </exl-expandable-text>
          </mat-list>
        </exl-content-box>
      }
      <!--    Links    -->
      @if (profileDataService.links.value && profileDataService.links.value.length > 0) {
        <exl-content-box>
          <div exl-content-box-title>
            <h2>
              {{ getLinksSectionTitle() | translate }}
            </h2>
          </div>
          <mat-list exl-content-box-body>
            <exl-expandable-text
              [buttonInline]="false"
              [buttonLabel]="'research.profile.overview.show.more' | translate"
              [visibleLines]="10"
              role="list"
              >
              @for (link of profileDataService.links.value; track link) {
                <mat-list-item
                  class="is-wrapping hasnt-padding"
                  role="listitem"
                  >
                  <mat-icon [ngClass]="'brand-' + link.icon" [svgIcon]="link.icon || 'file-url'" matListItemIcon>
                  </mat-icon>
                  <div>
                    <a
                                [aria-label]="
                                    'research.aria.profile.overview.links.open.link' | translate : { value: link.title }
                                "
                      [href]="link.url"
                      target="_blank"
                      >{{ link.title }}</a
                      >
                    </div>
                    @if (link.description) {
                      <div>
                        <span class="p">{{ link.description }}</span>
                      </div>
                    }
                  </mat-list-item>
                }
              </exl-expandable-text>
            </mat-list>
          </exl-content-box>
        }
        <!-- Honors -->
        @if (profileDataService.honors.value?.length) {
          <exl-content-box>
            <div exl-content-box-title>
              <h2>
                {{ 'research.profile.overview.honors' | translate }}
              </h2>
            </div>
            <mat-list exl-content-box-body>
              <exl-expandable-text
                [buttonInline]="false"
                [buttonLabel]="'research.profile.overview.show.more' | translate"
                [visibleLines]="10"
                role="list"
                >
                @for (honor of profileDataService.honors.value; track honor; let i = $index; let last = $last) {
                  <mat-list-item
                    class="is-wrapping hasnt-padding margin-bottom-xs"
                    role="listitem"
                    >
                    <div class="semibold" matLine>{{ honor.title }}</div>
                    <div matLine>
                      {{ honor.organizationCode | defaultTranslate : { default: honor.organizationName } }}
                      @if (honor.timePeriod) {
                        <span id="time-period-{{ i }}">, {{ honor.timePeriod }}</span>
                      }
                    </div>
                  </mat-list-item>
                }
              </exl-expandable-text>
            </mat-list>
          </exl-content-box>
        }
        @if (
          (profileDataService.curAffiliations.value && profileDataService.curAffiliations.value.length > 0) ||
          (profileDataService.prevAffiliations.value && profileDataService.prevAffiliations.value.length > 0)
          ) {
          <exl-content-box
            >
            <div exl-content-box-title>
              <h2>
                {{ 'research.profile.overview.affiliations' | translate }}
              </h2>
            </div>
            <div class="affiliations" exl-content-box-body>
              <exl-expandable-text
                [buttonInline]="false"
                [buttonLabel]="'research.profile.overview.show.more' | translate"
                [visibleLines]="6"
                >
                @for (affiliation of profileDataService.curAffiliations.value; track affiliation) {
                  <p class="margin-bottom-sm">
                    <esp-overview-affiliation-display
                      [affiliation]="affiliation"
                    ></esp-overview-affiliation-display>
                  </p>
                }
                @if (
                  profileDataService.prevAffiliations.value &&
                  profileDataService.prevAffiliations.value.length > 0
                  ) {
                  <ng-container
                    class="margin-bottom-sm"
                    >
                    <h3 class="h4 semibold">{{ 'research.profile.overview.affiliations.past' | translate }}</h3>
                    @for (affiliation of profileDataService.prevAffiliations.value; track affiliation) {
                      <p>
                        <esp-overview-affiliation-display
                          [affiliation]="affiliation"
                        ></esp-overview-affiliation-display>
                      </p>
                    }
                  </ng-container>
                }
              </exl-expandable-text>
            </div>
          </exl-content-box>
        }
        @if (
          profileService.isPublicPage &&
          profileDataService.researcherHighlights &&
          profileDataService.researcherHighlights.length > 0
          ) {
          <exl-content-box
            >
            <span exl-content-box-title>
              <h2>{{ 'research.profile.overview.highlights.output' | translate }}</h2>
            </span>
            <div exl-content-box-body>
              <exl-expandable-text
                [buttonInline]="false"
                [buttonLabel]="'research.profile.overview.show.more' | translate"
                [visibleLines]="20"
                >
                <esp-profile-highlights></esp-profile-highlights>
              </exl-expandable-text>
            </div>
          </exl-content-box>
        }
        @if (profileService.isPublicPage && profileDataService.researcherGrantsHighlights?.length) {
          <exl-content-box>
            <span exl-content-box-title>
              <h2>{{ 'research.profile.overview.highlights.awards' | translate }}</h2>
            </span>
            <div exl-content-box-body>
              <exl-expandable-text
                [buttonInline]="false"
                [buttonLabel]="'research.profile.overview.show.more' | translate"
                [visibleLines]="20"
                >
                <esp-profile-highlights-awards></esp-profile-highlights-awards>
              </exl-expandable-text>
            </div>
          </exl-content-box>
        }
        @if (profileDataService.educations.value && profileDataService.educations.value.length > 0) {
          <exl-content-box>
            <span exl-content-box-title>
              <h2>{{ 'research.profile.overview.education' | translate }}</h2>
            </span>
            <div exl-content-box-body>
              @for (education of profileDataService.educations.value; track education) {
                <div class="margin-bottom-sm">
                  <div class="semibold">
                    {{
                    education.fieldOfStudy
                    ? education.fieldOfStudy
                    : (education.organizationCode
                    | defaultTranslate : { default: education.organizationName })
                    }}
                  </div>
                  <div>
                    @if (education.year) {
                      {{ education.year | espdateformat }}
                    }
                    @if (education.toDateYear && education.year) {
                      &ndash;
                    }
                    @if (education.toDateYear) {
                      {{
                      education.toDateYear | espdateformat
                      }}
                    }
                    @if (
                      (education.toDateYear || education.year) &&
                      (education.degree || (education.organizationName && education.fieldOfStudy))
                      ) {
                      ,
                    }
                    @if (education.degree) {
                      {{ education.degree }}
                    }
                    @if (education.degree && education.organizationName && education.fieldOfStudy) {
                      ,
                    }
                    @if (education.organizationName && education.fieldOfStudy) {
                      {{
                      education.organizationCode | defaultTranslate : { default: education.organizationName }
                      }}
                    }
                  </div>
                  @if (education.additionalDetails) {
                    <p>{{ education.additionalDetails }}</p>
                  }
                </div>
              }
            </div>
          </exl-content-box>
        }
      </div>
    }

    <div class="aside-content">
      @if (profileDataService.identifiers.value && this.profileDataService.identifiers.value.length > 0) {
        <exl-content-box
          >
          <div exl-content-box-title>
            <h2>{{ 'research.profile.overview.global.id' | translate }}</h2>
          </div>
          <div exl-content-box-body>
            <exl-expandable-text
              [buttonInline]="false"
              [buttonLabel]="'research.profile.overview.show.more' | translate"
              [visibleLines]="8"
              >
              @for (identifier of profileDataService.identifiers.value; track identifier; let last = $last) {
                <div
                  [class.margin-bottom-sm]="!last"
                  class="id-wrap"
                  >
                  @if (!isOrcid(identifier)) {
                    <span
                      [class.cdk-visually-hidden]="isWosId(identifier)"
                      class="semibold margin-right-xs"
                      >{{ identifier.type | translate }}</span
                      >
                    }
                    @if (!displayAsHref(identifier)) {
                      <span class="global-id-value">{{ identifier.value }}</span>
                    }
                    @if (isWosId(identifier)) {
                      <mat-icon
                        [matTooltip]="identifier.type | translate"
                        class="margin-right-xs"
                        muloSvgViewbox
                        svgIcon="clarivate"
                      ></mat-icon>
                    }
                    @if (displayAsHref(identifier) && !isOrcid(identifier)) {
                      <a
                        [href]="getHref(identifier)"
                        class="global-id-value"
                        target="_blank"
                        >{{ identifier.value }}
                      </a>
                    }
                    @if (isOrcid(identifier)) {
                      <mulo-orcid-link
                        [orcidId]="identifier.value"
                        idDescription="{{ 'research.general.orcid.profile.tooltip' | translate }}"
                        logoTooltip="{{ 'research.general.orcid.website.tooltip' | translate }}"
                        >
                      </mulo-orcid-link>
                    }
                  </div>
                }
              </exl-expandable-text>
            </div>
          </exl-content-box>
        }

        <!-- Metrics -->
        @if (profileDataService.metrics.value; as metrics) {
          @if (profileService.metricsLoading) {
            <content-loader
              [rtl]="i18nSvc.isLangRtl()"
              [style]="{ height: 135, width: 200, marginBlockEnd: '3rem' }"
              backgroundColor="#dddddd"
              foregroundColor="#eeeeee"
              viewBox="0,0,200,135"
              >
              <svg:rect height="30" rx="2" ry="2" width="90" x="0" y="0" />
              <svg:rect height="10" rx="2" ry="2" width="200" x="0" y="40" />
              <svg:rect height="10" rx="2" ry="2" width="180" x="0" y="60" />
              <svg:rect height="10" rx="2" ry="2" width="160" x="0" y="80" />
            </content-loader>
          }
          @if ((metrics | keyvalue).length > 0) {
            <exl-content-box>
              <div exl-content-box-title>
                <h2 translate>research.profile.overview.metrics</h2>
              </div>
              <ul exl-content-box-body>
                @for (metric of metrics | keyvalue; track metric) {
                  <li class="metrics-entry">
                    <mat-icon
                      class="metrics-icon"
                      [class.mat-icon-rtl-mirror]="metricIconMap[metric.key] === 'message-text'"
                      muloSvgViewbox
                      [svgIcon]="metricIconMap[metric.key]"
                    ></mat-icon>
                    <span class="metrics-count">{{ metric.value }}&nbsp;</span>
                    <span class="metrics-type">{{
                      'research.profile.overview.metrics.' + metric.key | translate
                    }}</span>
                  </li>
                }
              </ul>
            </exl-content-box>
          }
        }

        <!-- Emails -->
        @if (profileDataService.emails.value && profileDataService.emails.value.length > 0) {
          <exl-content-box>
            <div exl-content-box-title>
              <h2>
                {{ getEmailsSectionTitle() | translate }}
              </h2>
            </div>
            <div exl-content-box-body>
              @for (email of profileDataService.emails.value; track email; let last = $last) {
                <div
                  [ngClass]="{ 'margin-bottom-xs': !last }"
                  >
                  <a
                        attr.aria-label="{{
                            'research.aria.profile.overview.email.mailto' | translate : { value: email }
                        }} {{ 'research.aria.profile.overview.email.open' | translate }}"
                    href="mailto:{{ email }}"
                    >
                    {{ email }}
                  </a>
                </div>
              }
            </div>
          </exl-content-box>
        }

        <!-- Phones -->
        @if (profileDataService.phones.value && profileDataService.phones.value.length > 0) {
          <exl-content-box>
            <div exl-content-box-title>
              <h2>
                {{ getPhonesSectionTitle() | translate }}
              </h2>
            </div>
            <ng-container exl-content-box-body>
              @for (phone of profileDataService.phones.value; track phone; let last = $last) {
                <div
                  [class.margin-bottom-xs]="!last"
                  class="phone-entry"
                  >
                  <span class="semibold margin-right-xs">{{ phone.type | translate }}</span>
                  <span>{{ phone.phone }}</span>
                </div>
              }
            </ng-container>
          </exl-content-box>
        }

        <!-- Addresses -->
        @if (profileDataService.addresses.value && profileDataService.addresses.value.length > 0) {
          <exl-content-box>
            <div exl-content-box-title>
              <h2>
                {{ getAddressesSectionTitle() | translate }}
              </h2>
            </div>
            <div class="addresses" exl-content-box-body>
              <exl-expandable-text
                [buttonInline]="false"
                [buttonLabel]="'research.profile.overview.show.more' | translate"
                [visibleLines]="8"
                >
                @for (address of profileDataService.addresses.value; track address; let last = $last) {
                  <div
                    [ngClass]="{ 'margin-bottom-sm': !last }"
                    class="address-entry"
                    >
                    <span>{{ address.line1 }}</span>
                    @if (address.line2) {
                      <span>{{ address.line2 }}</span>
                    }
                    @if (address.line3) {
                      <span>{{ address.line3 }}</span>
                    }
                    @if (address.line4) {
                      <span>{{ address.line4 }}</span>
                    }
                    @if (address.line5) {
                      <span>{{ address.line5 }}</span>
                    }
                    <span>
                      @if (address.city) {
                        <span>{{ address.city }}</span>
                      }
                      @if (address.city && address.postalCode) {
                        &nbsp;
                      }
                      @if (address.postalCode) {
                        <span>{{ address.postalCode }}</span>
                      }
                    </span>
                    @if (address.country) {
                      <span>{{ address.country | translate }}</span>
                    }
                  </div>
                }
              </exl-expandable-text>
            </div>
          </exl-content-box>
        }
      </div>
    </section>
